export const CommonMessages = {
    required: (label) => `${label} is required.`,
    string: (label) => `${label} must be a string.`,
    minLength: (label, min) => `${label} must be at least ${min} characters.`,
    maxLength: (label, max) => `${label} may not be greater than ${max} characters.`,
    email: () => 'Please enter a valid email address.',
    unique: () => 'The value has already been taken.',
    confirmed: (label) => `${label} confirmation does not match.`,
    numeric: (label) => `${label} must be a number.`,
    integer: (label) => `${label} must be an integer.`,
    in: () => 'The selected value is invalid.',
    date: (label) => `${label} must be a valid date.`,
    after: (label, date) => `${label} must be a date after ${date}.`,
    before: (label, date) => `${label} must be a date before ${date}.`,
    boolean: (label) => `${label} must be true or false.`,
    array: (label) => `${label} must be an array.`,
    file: (label) => `${label} must be a file.`,
    mimes: (label, types) => `${label} must be a file of type: ${types}.`,
    exists: () => 'The selected value is invalid.',
    regex: (label) => `${label} format is invalid.`,
}